import http from "../../../../Utils/http";

export function ProfileData() {
    return http.get(`api/laboratory/profile`);
  }

  export function EditData(data) {
    return http.post(`api/laboratory/profile`, data);
  }